import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ICharge } from 'src/app/pages/core/models/Commerce';

@Component({
  selector: 'app-charge-confirm',
  templateUrl: './charge-confirm.component.html',
  styleUrls: ['./charge-confirm.component.scss'],
})
export class ChargeConfirmComponent implements OnInit {
  remainTime: Date;
  successCopy = false;
  constructor(
    public dialogRef: MatDialogRef<ChargeConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { charge: ICharge },
  ) {}

  ngOnInit(): void {
    this.data.charge.price.currency.replace('S', '$');
    this.setCountdownTime();
  }

  close() {
    this.dialogRef.close();
  }

  getRemainTime() {
    if (this.remainTime) {
      const seconds = this.remainTime.getSeconds();
      const minutes = this.remainTime.getMinutes();
      let hours = this.remainTime.getHours();
      const days = Math.floor(this.remainTime.getTime() / 1000 / 60 / 60 / 24);
      let timeString = '';
      if (days > 0) {
        timeString += days + (days > 1 ? ' días ' : ' día ');
      } else {
        hours = Math.floor(this.remainTime.getTime() / 1000 / 60 / 60);
      }
      if (days > 0 || hours > 0) {
        timeString += hours + 'h '; //('0' + hours).slice(-2) + 'h ';
      }
      if (minutes > 0) {
        timeString += minutes + 'm '; //('0' + minutes).slice(-2) + 'm ';
      }
      if (minutes <= 0) {
        timeString += seconds + 's'; //('0' + seconds).slice(-2) + 's';
      }
      return timeString;
    }
  }

  setCountdownTime() {
    const timeUnit = 1000 * 60; //minute
    this.remainTime = new Date(this.data.charge.creation_time);
    this.remainTime.setTime(
      this.remainTime.getTime() + this.data.charge.ttl * timeUnit - new Date().getTime(),
    );
    setInterval(() => {
      if (this.remainTime.getTime() > 1) {
        this.remainTime.setTime(this.remainTime.getTime() - 1000);
      } else {
        this.remainTime.setTime(0);
      }
    }, 1000);
  }

  copyUrl() {
    this.successCopy = true;
    window.navigator.clipboard.writeText(this.data.charge.hosted_url);
    setTimeout(() => {
      this.successCopy = false;
    }, 1000);
  }
}
